//@ts-check
import React from 'react';
import Formatter from '../../../formatter';
import getFileThumbnailPath from '../../../utils/pathUtil/getFileThumbnailPath';
var ENGAGEMENT_PROJECT_FILTERS = ['touchpointId'];
/** @type {import('../types').DataType<import('./types').EngagementProjectDataModel>} */

var ENGAGEMENT_PROJECT_DATA_TYPE = {
  data: {
    url: '/backend/journeys/{journeyId}/communications',
    dataKey: 'engagementProject',
    idKeyProp: 'UID',
    by: 'MainTouchpoint',
    onBeforeRequest: function onBeforeRequest(options, request) {
      if (request.type === 'loadView' && options.dataProps) {
        var filter = {};
        Object.keys(options.dataProps).map(function (f) {
          if (ENGAGEMENT_PROJECT_FILTERS.indexOf(f) > -1) filter[f] = options.dataProps[f];
        });
        return {
          query: filter,
          url: request.url.replace('{journeyId}', options.dataProps.journeyId)
        };
      }
    }
  },
  columns: [{
    id: 'Name',
    children: 'Name',
    serverSort: true,
    formatter: function formatter(_ref) {
      var data = _ref.data;
      return React.createElement(Formatter.DataLink, {
        dataType: "project",
        data: data
      });
    },
    width: {
      lg: '25%',
      sm: '40%',
      xs: '50%'
    }
  }, {
    id: 'Description',
    children: 'Description',
    formatter: function formatter(_ref2) {
      var data = _ref2.data;
      return React.createElement(Formatter.Text, {
        value: data.Description
      });
    },
    width: {
      lg: '25%',
      md: 0,
      sm: 0,
      xs: 0
    }
  }, {
    id: 'MainStage',
    children: 'Stage',
    serverSort: true,
    formatter: function formatter(_ref3) {
      var data = _ref3.data;
      return React.createElement(Formatter.JourneyStage, {
        value: data.MainStage.Name,
        color: data.MainStage.Color
      });
    }
  }, {
    id: 'MainTouchpoint',
    children: 'Touchpoint',
    serverSort: true,
    formatter: function formatter(_ref4) {
      var data = _ref4.data;
      return React.createElement(Formatter.JourneyTouchpoint, {
        value: data.MainTouchpoint.Name,
        color: data.MainTouchpoint.Color,
        type: data.MainTouchpoint.IsMilestone ? 'milestone' : 'touchpoint'
      });
    },
    width: {
      md: 'auto',
      sm: 0,
      xs: 0
    }
  }, // {
  //   id: 'Sequence',
  //   children: 'Sequence',
  //   formatter: function SequenceFormatter({ data }) {
  //     return <Formatter.Text value={data.Id} />;
  //   },
  // },
  {
    id: 'Author',
    children: 'Author',
    formatter: function formatter(_ref5) {
      var data = _ref5.data;
      return React.createElement(Formatter.Text, {
        value: data.Author
      });
    },
    width: {
      lg: 'auto',
      md: 0,
      sm: 0,
      xs: 0
    }
  }, {
    id: 'LastModifiedUTC',
    children: 'Last Updated',
    serverSort: true,
    formatter: function formatter(_ref6) {
      var data = _ref6.data;
      return React.createElement(Formatter.DateTime, {
        value: data.LastModifiedUTC
      });
    },
    width: {
      sm: 'auto',
      xs: 0
    }
  }],
  thumbnail: {
    url: function url(data) {
      return data.Path ? getFileThumbnailPath({
        path: data.Path,
        workspace: data.Workspace,
        token: data.ResourceToken
      }) : null;
    },
    text: function text(data) {
      return data.Name;
    },
    icon: function icon(data) {
      return data.Type;
    }
  },
  placeholders: {
    label: function label(data) {
      return data ? data.Name : '';
    },
    type: 'project',
    icon: function icon(data) {
      if (!data) return 'project';
      return data.Type;
    }
  }
};
export default ENGAGEMENT_PROJECT_DATA_TYPE;